import { useEffect } from 'react';

export function useDocumentMeta({ title, description, image, url, price, currency, type }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (property, content) => {
      if (!content) return;
      let tag = document.querySelector(`meta[property="${property}"]`) || document.querySelector(`meta[name="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        if (property.startsWith('og:') || property.startsWith('product:')) {
          tag.setAttribute('property', property);
        } else {
          tag.setAttribute('name', property);
        }
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('og:title', title);
    setMeta('og:description', description);
    setMeta('og:image', image);
    setMeta('og:url', url);
    setMeta('og:type', type || 'website');
    if (price) {
      setMeta('product:price:amount', String(price));
      setMeta('product:price:currency', currency || 'EUR');
    }

    return () => {
      document.title = 'Equi-Market - European Horse Marketplace';
    };
  }, [title, description, image, url, price, currency, type]);
}
